{
  "id": "campaign-135",
  "name": "Derby Ground",
  "seed": "campaign:135",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r.....QQQQ.....r",
    "..x:..,,,...:...",
    ".a.:a.a,.a.a:.a.",
    "...::::::::::...",
    "......a..a......",
    ".a.a........a.a.",
    "......a..a......",
    ".............x..",
    "....a..~.,.a....",
    "::::::::::::::::",
    ".......~.,......",
    ".,.,a......a.#.#",
    "................",
    "......a..a......",
    "...::::::::::...",
    "...:..~~~...:...",
    "...:........:...",
    "S.....QQQQ......"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 2,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 12,
      "y": 15
    },
    {
      "kind": "rabbit",
      "x": 11,
      "y": 7
    },
    {
      "kind": "rabbit",
      "x": 8,
      "y": 13
    },
    {
      "kind": "rabbit",
      "x": 5,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 14,
      "y": 15
    },
    {
      "kind": "gas",
      "x": 8,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 8
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "balls": {
    "first": 18,
    "every": 12
  },
  "generatorVersion": 3,
  "level": 135,
  "biome": "stadium",
  "par": {
    "reel": 9829,
    "push": 8181,
    "selfPropelled": 7440,
    "tractor": 6330,
    "zeroTurn": 5412,
    "fairway": 3457
  },
  "goldTime": {
    "reel": 9529,
    "push": 8012,
    "selfPropelled": 7440,
    "tractor": 6330,
    "zeroTurn": 5361,
    "fairway": 3341
  },
  "routeTries": {
    "par": {
      "reel": 23,
      "push": 0,
      "selfPropelled": 3,
      "tractor": 11,
      "zeroTurn": 15,
      "fairway": 13
    },
    "gold": {
      "reel": 39,
      "push": 38,
      "selfPropelled": 3,
      "tractor": 11,
      "zeroTurn": 25,
      "fairway": 49
    }
  }
}
